var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H6.07997M28 26H25.92M18.5 26H13.5M18.5 26V19.9844C18.5 19.7233 18.4122 19.4729 18.2559 19.2883C18.0996 19.1037 17.8877 19 17.6667 19H14.3333C14.1123 19 13.9004 19.1037 13.7441 19.2883C13.5878 19.4729 13.5 19.7233 13.5 19.9844V26M18.5 26H25.92M13.5 26H6.07997M25.92 26L26 15.3525C25.998 15.2242 25.9708 15.0976 25.92 14.9801C25.8693 14.8627 25.796 14.7568 25.7045 14.6687L16.6136 6.24309C16.446 6.08672 16.2271 6 16 6C15.7729 6 15.554 6.08672 15.3864 6.24309L6.29545 14.6687C6.20397 14.7568 6.13071 14.8627 6.07997 14.9801C6.02922 15.0976 6.00204 15.2242 6 15.3525L6.07997 26",
    stroke: "#393A40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingType);
export default __webpack_public_path__ + "static/media/buildingType.113a28145c7fcec093d2dbae326fcf5c.svg";
export { ForwardRef as ReactComponent };